import { Amplitude } from './ampitude';
import { AMPLITUDE_OPTIONS } from '@/analytics/constants';
import { useStore } from 'vuex';
import { computed, watch } from 'vue';

export const useAnalytics = () => {
  const store = useStore();
  const authToken = computed(() => store.getters.authToken);

  const initAnalytics = async () => {
    try {
      await Amplitude.init(process.env.VUE_APP_AMPLITUDE_API_KEY, AMPLITUDE_OPTIONS).promise;
    } catch (e) {
      console.error('Failed to initialize Amplitude', e);
    }
  };

  watch(authToken, (token) => {
    if (!token) {
      Amplitude.reset();
    }
  });

  return { initAnalytics };
};